export default "__VITE_ASSET__3a671f8a__"